import 'core-js/es/map';
import 'core-js/es/set';
import 'raf/polyfill';

import React, { Component } from 'react'
import Web3Gate from "./components/web3Gate"
import "./assets/less/index.less"
import AppContent from "./components/appComponents/appContent"


/**
 * Declare your application specific contracts here
 */
const contractMevu = require ("./contracts/Mevu.json");
const contractEventsController = require ("./contracts/EventsController.json");
const contractEvents = require ("./contracts/Events.json");
const contractWagers = require ("./contracts/Wagers.json");
const contractWagersController = require ("./contracts/WagersController.json");
const contractCustomWagers = require ("./contracts/CustomWagers.json");
const contractCustomWagersController = require ("./contracts/CustomWagersController.json");
const contractAdmin = require("./contracts/Admin.json");
const contractOracleVerifier = require("./contracts/OracleVerifier.json");
const contractMvuToken = require("./contracts/MvuToken.json");
const contractOracles = require("./contracts/Oracles.json");
const contractOraclesController = require("./contracts/OraclesController.json");
const contractCancelController = require('./contracts/CancelController.json');
const contractRewards = require('./contracts/Rewards.json');
const contractPoolWagers = require('./contracts/PoolWagers.json');
const contractPoolWagersController = require('./contracts/PoolWagersController.json');
const contractDice = require('./contracts/Dice.json');
class App extends Component {
    render() {
        return (
            <Web3Gate
                /**
                 * pass the declared contract objects as props here
                 */
                contracts={[
                    contractMevu,
                    contractEventsController,
                    contractEvents,
                    contractWagers,
                    contractWagersController,
                    contractCustomWagers,
                    contractCustomWagersController,
                    contractAdmin,
                    contractOracles,
                    contractOracleVerifier,
                    contractOraclesController,
                    contractCancelController,
                    contractMvuToken,
                    contractRewards,
                    contractPoolWagers,
                    contractPoolWagersController,
                    contractDice
                ]}

                /**
                 * declare websocket endpoints for event management here
                 */
                event_providers={{
                    main: "wss://mainnet.infura.io/ws",
                    rinkeby: "wss://rinkeby.infura.io/ws",
                    local: "ws://127.0.0.1:8545"
                }}
            >
                {
                    // AppContent can be deleted
                }
                <AppContent />

            </Web3Gate>
        )
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js